import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "smallHeroImg",
    src: "https://s3.eu-west-2.amazonaws.com/content.sysodev.link/1a813d88-19f8-4cc8-9ac2-c7b3ba308c74.svg"
};
const _hoisted_4 = { class: "anchor-bottom" };
const _hoisted_5 = { href: "mailto:" };
import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AwaitEmailVerificationPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        useAuth();
        const { getEmployerLogo, emailIsVerified } = useCustomer();
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const employerName = ref(null);
        const logo = ref(null);
        let interval = null;
        function awaitValidation() {
            const emailVerificationId = route.params.id;
            emailIsVerified(emailVerificationId, () => {
                if (interval) {
                    clearInterval(interval);
                }
                router.push({ path: '/eligibilityverified' });
            });
        }
        function onLoad() {
            const employerId = cookies?.get('employerId');
            employerName.value = route.params.employer;
            getEmployerLogo(employerId, (logoUrl) => {
                logo.value = logoUrl;
            });
            interval = setInterval(() => {
                awaitValidation();
            }, 3000);
        }
        onMounted(() => {
            onLoad();
        });
        onUnmounted(() => {
            if (interval) {
                clearInterval(interval);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Welcome to ", -1)),
                    _createElementVNode("h1", null, _toDisplayString(employerName.value), 1),
                    _createElementVNode("p", null, "Great news, " + _toDisplayString(employerName.value) + " is one of our supported employers.", 1),
                    (logo.value && logo.value != '')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "smallHeroImg",
                            src: logo.value
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    (!logo.value || logo.value == '')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, "An email has been sent to your work account. Please open the email and click on the verification link. (Don't forget to check your Junk/Spam folders.)", -1)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("a", _hoisted_5, [
                            _createVNode(MGButton, { text: "Open Email" })
                        ]),
                        _createElementVNode("div", {
                            class: "mt-3",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).back()))
                        }, "I didn't receive an email")
                    ])
                ])
            ], 64));
        };
    }
});
